import React from 'react';
import EmailTemplateList from '../../../components/email-templates/EmailTemplateList';
import HorizontalFormBlockWrapper from '../../../components/forms/HorizontalFormBlockWrapper';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import FormFooter from '../../_layout/_footers/form-footer';
import { useSettingsProvider } from '../provider/SettingsProvider';

const TemplatesSettingsPage: React.FC = () => {

    const { formik, isLoading, hasCompanyConfigChanges, setShowModal, discardCompanyConfigChanges } = useSettingsProvider();

    const pageHeader = {
        title: 'Ajustes en Plantillas',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Configuración' },
            { name: 'Plantillas', href: menuRoutes.settings.path + menuRoutes.settings.templates },
        ]
    }

    return (
        <div className='h-full overflow-auto scrollbar'>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} className='border-b-4 border-dotted border-grey-500 top-0' />

            <HorizontalFormBlockWrapper
                title="Plantillas de Email"
                description="Gestiona las plantillas predefinidas para enviar correos electrónicos estandarizados desde las fichas de cliente o contrato. Puedes crear, editar y organizar plantillas con contenido dinámico y adjuntos."
                descriptionClassName="max-w-full"
                childrenWrapperClassName="@3xl:grid-cols-1 max-w-full w-full"
            >
                <EmailTemplateList />
            </HorizontalFormBlockWrapper>

            {hasCompanyConfigChanges && (
                <FormFooter
                    customClassName={"w-full"}
                    submitBtnText={"Aplicar Cambios"}
                    cancelBtnText={"Descartar Cambios"}
                    handleCancelBtn={() => discardCompanyConfigChanges()}
                    handleSubmitBtn={() => setShowModal(true)}
                    isLoading={isLoading}
                    isDisabled={Object.keys(formik.errors).length > 0}
                />
            )}
        </div>
    );
};

export default TemplatesSettingsPage;